import styled from 'styled-components';
import {
  Input,
  InputAdornment,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { Box } from '@mui/system';
import { BasicInput } from '../../components/common/InputDropdown';
import { LoadingButton } from '@mui/lab';

export const StyledInput = styled(Input)`
  background-color:#f8fafb;
  border-radius:4px;
  width:100%;
  padding:11px 15px;
  border:none;
  color:#25CEDE;
  font-size:16px;
  font-weight:500;
  letter-spacing:0.1px;
  min-width:346px;
  border:solid 1px transparent;
  &.Mui-error {
    border:solid 1px red;
  }
`;

export const StyledIcon = styled(InputAdornment)`
  margin-right:19px;
`;

export const StyledLink = styled(Link)`
  text-decoration: none !important;
`;

export const MainPoliciesWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 48px;
  max-width: 516px;
  width: 100%;
`;

export const PoliciesFormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 48px;
  gap: 32px;
  width: 100%;
  max-width: 516px;

  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(32px);

  border-radius: 8px;
`;

export const MainLoginWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 48px;
  max-width: 516px;
  width: 100%;
`;

export const LoginFormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 440px;
`;

export const CommonPagesWrapper = styled(Box)`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.64);
`;

export const CustomBasicInput = styled(BasicInput)`
  background-color: transparent !important;

  input {
    border: 1px solid #475467 !important;
    color: #98A2B3 !important;
    background-color: transparent !important;
  }
  & .MuiInputBase-root {
    background-color: transparent !important;
  }
`;

export const TextWrapper = styled(Box)`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const LoginButton = styled(LoadingButton)`
  :disabled {
    background-color: rgba(91, 138, 197, 0.24) !important;
    color: #667085;
  }
`;
